// extracted by mini-css-extract-plugin
export var deleteModal = "_k7-0";